import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getUserInfo } from "../utils/auth";
import {
  ROLE,
  URL_S001,
  URL_S003,
  URL_S005,
  URL_S008,
} from "../utils/constants";

function getDefaultLink() {
  const role = getUserInfo().userRole;
  if (role === ROLE.entry) {
    return URL_S003 + "/1";
  } else if (role === ROLE.user) {
    return URL_S001;
  } else if (role === ROLE.manager) {
    return URL_S005;
  } else if (role === ROLE.hr) {
    return URL_S008;
  }
  return "/home";
}

function isAuthorized(requirements) {
  const role = getUserInfo().userRole;
  if (requirements.find((item) => item === role)) return true;
  return false;
}

const AuthorizedRoute = ({ component: Component, requirements, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthorized(requirements) ? (
          <Component {...props} />
        ) : (
          <Redirect to={getDefaultLink()} />
        )
      }
    />
  );
};
export default AuthorizedRoute;
